import "./style.css";

import React from "react";

import SafeVideoLogo from "../../../Video/Controls/SafeLogo";

interface IAudioPlaybackRateProps {
  playbackRate: number;
  onPlaybackRateChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const AudioPlaybackRate: React.FC<IAudioPlaybackRateProps> = ({
  playbackRate,
  onPlaybackRateChange,
}) => (
  <div className="audio-playback-rate-wrapper">
    <select
      value={playbackRate}
      onChange={onPlaybackRateChange}
      className="audio-playback-rate"
    >
      <option value="0.5">0.5x</option>
      <option value="1">1x</option>
      <option value="1.5">1.5x</option>
      <option value="2">2x</option>
    </select>
    <SafeVideoLogo />
  </div>
);

export default AudioPlaybackRate;
